import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "materialize-css/dist/css/materialize.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
